import httpService from "@/services/httpService";
import {baseUrl} from "@/config"


const endpoint = baseUrl + "/Admin"


const getOrganizationsPaged = async (request) => {
    try {
        const response = await httpService.post(endpoint + '/GetOrganizationsPaged', request)
        return response
    } catch (e) {
    }
}

const getHubspotCompaniesWithoutNces = async (request) => {
    try {
        const response = await httpService.post(endpoint + '/GetHubspotCompaniesWithoutNces', request)
        return response
    } catch (e) {
    }
}
const updateHubspotCompanyModel = async (request) => {
    try {
        const response = await httpService.post(endpoint + '/UpdateHubspotCompanyModel', request)
        return response
    } catch (e) {
    }
}
const getAdminAccounts = async (orgId) => {
    try {
        return await httpService.post(endpoint + '/GetAdminAccounts?orgId=' + orgId )
    } catch (e) {

    }
}

const getPostSecondarySchoolsJson = async () => {
    try {
        return await httpService.get(endpoint + '/PostSecondarySchoolsJson')
    } catch (e) {
    }
}

const getPublicHighSchoolsJson = async () => {
    try {
        return await httpService.get(endpoint + '/PublicHighSchoolsJson')
    } catch (e) {
    }
}

const getPrivateSchoolsJson = async () => {
    try {
        return await httpService.get(endpoint + '/PrivateSchoolsJson')
    } catch (e) {
    }
}

const getPublicSchoolDistrictsJson = async () => {
    try {
        return await httpService.get(endpoint + '/PublicSchoolDistrictsJson')
    } catch (e) {
    }
}









export {
    getOrganizationsPaged,
    getHubspotCompaniesWithoutNces,
    updateHubspotCompanyModel,
    getAdminAccounts,
    getPostSecondarySchoolsJson,
    getPublicHighSchoolsJson,
    getPrivateSchoolsJson,
    getPublicSchoolDistrictsJson
}